import React from 'react';

type Props = {
  label: string;
  value: string;
  icon: React.ReactNode;
};

const InfoBox = ({ label, value, icon }: Props) => {
  return (
    <div className="border-border-neutral-mid flex min-w-0 flex-col rounded-lg border px-2 py-2">
      <div className="mb-1 h-4 w-4 shrink-0">{icon}</div>
      <p className="font-regular text-text-brand text-[12px] leading-snug break-words xl:text-[14px]">
        {label}
      </p>
      <p className="font-regular text-text-placeholder-dark text-[12px] leading-snug break-words xl:text-[14px]">
        {value}
      </p>
    </div>
  );
};

export default InfoBox;
